interface ITime {
  13: string;
  14: string;
  15: string;
  16: string;
  17: string;
  18: string;
  19: string;
  20: string;
  21: string;
  22: string;
  23: string;
  [key: number]: string;
}

const beforenoon = (data: string) => {
  if (data.toLocaleLowerCase().trim() === "closed") return data;

  return data.replace(/[^:\d]/g, "");
};

const afternoon = (data: string) => {
  const beforeNoon = ["00", "01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11"];
  const afterNoon = ["00", "13", "14", "15", "16", "17", "18", "19", "20", "21", "22", "23", "12"];

  if (data.toLocaleLowerCase().trim() === "closed") return data;
  const time = data.replace(/[^:-\d]/g, "").split(":");

  if (+time[0] < 12 && data.includes("am")) {
    return `${beforeNoon[+time[0]]}:${time[1]}`;
  }

  if (+time[0] < 12) {
    return `${afterNoon[+time[0]]}:${time[1]}`;
  }

  return data.replace(/[^:\d]/g, "");
};

const timeUS = (data: string[]) => {
  const time: ITime = {
    13: "01",
    14: "02",
    15: "03",
    16: "04",
    17: "05",
    18: "06",
    19: "07",
    20: "08",
    21: "09",
    22: "10",
    23: "11",
  };
  const timeAfternoon = data[1].replace(/[^:' '\d]/g, "").split(":");

  if (+timeAfternoon[0] <= 12) {
    return `${data[0]} - ${data[1]}`;
  }

  const property: number = +timeAfternoon[0];
  return `${data[0]} - ${time[property]}:${timeAfternoon[1]} pm`;
};

const formatedOpenTime = (data: string, userCountry: string | undefined) => {
  if (data.toLocaleLowerCase() === "closed" || data.toLocaleLowerCase() === "closed - closed") {
    return "Closed";
  }

  if (!data) return "Closed";
  if (data === "open 24hrs") return "open 24hrs";

  const dataTime = data.split("-");

  if (userCountry === "en-US") {
    return timeUS(dataTime);
  }

  return `${beforenoon(dataTime[0])} - ${afternoon(dataTime[1])}`;
};

export default formatedOpenTime;
